export default {
  CRITICAL: 'CRITICAL',
  ALERT: 'ALERT',
  NORMAL: 'NORMAL'
};
